import moment, { type Moment } from 'moment-timezone';
import { TIME_ZONE_CONSTANTS } from '@/utils/timeZoneConstants';

/** moment `z` often returns numeric offsets (e.g. "-03"); prefer named abbr or GMT offset. */
function looksLikeNumericTzAbbreviation(s: string | null | undefined): boolean {
  if (s === null || s === undefined || s === '') return true;
  const t = String(s).trim();
  return /^[-+]\d{1,2}$/.test(t) || /^[-+]\d{2}:\d{2}$/.test(t);
}

/**
 * Short timezone label for display (e.g. IST, PST, GMT+05:30).
 * Uses moment's zone abbr when it is a real name; otherwise TIME_ZONE_CONSTANTS, then GMT±offset.
 */
export function formatTimezoneAbbreviationForDisplay(
  m: Moment,
  ianaKey: string | null | undefined
): string {
  const trimmedKey =
    typeof ianaKey === 'string' && ianaKey.trim() !== ''
      ? ianaKey.trim()
      : null;

  if (trimmedKey && moment.tz.zone(trimmedKey)) {
    const fromMoment = (m.format('z') || '').trim();
    const fromConstants =
      TIME_ZONE_CONSTANTS[trimmedKey as keyof typeof TIME_ZONE_CONSTANTS]
        ?.abbreviation;
    if (fromMoment && !looksLikeNumericTzAbbreviation(fromMoment)) {
      return fromMoment;
    }
    if (fromConstants) return fromConstants;
  }

  return `GMT${m.format('Z')}`;
}
